import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgPin1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M4.543 4.508C5.867 2.522 8.191 1 12 1c3.81 0 6.133 1.522 7.457 3.508C20.736 6.426 21 8.65 21 10c0 3.495-1.46 6.338-3.23 8.475-1.764 2.13-3.87 3.604-5.28 4.397a1 1 0 0 1-.98 0c-1.41-.793-3.516-2.266-5.28-4.397C4.46 16.338 3 13.495 3 10c0-1.349.264-3.574 1.543-5.492'
      clipRule='evenodd'
      opacity={0.2}
    />
    <path fill='#fff' d='M12 11.5q2.5 0 2.5-2.5T12 6.5 9.5 9t2.5 2.5' />
    <path
      fill='#fff'
      fillRule='evenodd'
      d='M12 1C8.19 1 5.867 2.522 4.543 4.508 3.264 6.426 3 8.65 3 10c0 3.495 1.46 6.338 3.23 8.475 1.764 2.13 3.87 3.604 5.28 4.397a1 1 0 0 0 .98 0c1.41-.793 3.516-2.266 5.28-4.397C19.54 16.338 21 13.495 21 10c0-1.349-.264-3.574-1.543-5.492C18.133 2.522 15.81 1 12 1m-7 9c0-1.151.236-2.926 1.207-4.383C7.133 4.228 8.809 3 12 3c3.19 0 4.867 1.228 5.793 2.617C18.764 7.074 19 8.85 19 10c0 2.905-1.207 5.312-2.77 7.2-1.376 1.661-3.003 2.887-4.23 3.64-1.227-.753-2.854-1.979-4.23-3.64C6.207 15.312 5 12.905 5 10'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgPin1)
export default ForwardRef
